module.exports = __webpack_public_path__ + "static/media/arrow-left-icon.dd39d5ba.svg";